import * as v from 'valibot';

export const FilePondOutputValidationModel = v.record(
    v.string(),
    v.object({
        url: v.string(),
        fields: v.object({
            key: v.string(),
            AWSAccessKeyId: v.string(),
            policy: v.string(),
            signature: v.string()
        })
    })
);
export type FilePondOutputValidationType = v.InferOutput<typeof FilePondOutputValidationModel>;
